module.exports = __webpack_public_path__ + "static/media/orderedlist.846c5158.svg";